import { render, staticRenderFns } from "./FieldCard.vue?vue&type=template&id=18848381&scoped=true&lang=pug&"
import script from "./FieldCard.vue?vue&type=script&lang=js&"
export * from "./FieldCard.vue?vue&type=script&lang=js&"
import style0 from "./FieldCard.vue?vue&type=style&index=0&id=18848381&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18848381",
  null
  
)

/* custom blocks */
import block0 from "./FieldCard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports